import request from '@/utils/request'

// 查询【联系人】列表
export function queryListContact(query) {
  return request({
    url: '/scrm/contact/queryList',
    method: 'get',
    params: query
  })
}

// 查询【联系人】列表
export function listContact(query) {
  return request({
    url: '/scrm/contact/list',
    method: 'get',
    params: query
  })
}

// 查询【联系人】详细
export function getContact(contactId) {
  return request({
    url: '/scrm/contact/' + contactId,
    method: 'get'
  })
}

// 新增【联系人】
export function addContact(data) {
  return request({
    url: '/scrm/contact',
    method: 'post',
    data: data
  })
}

// 修改【联系人】
export function updateContact(data) {
  return request({
    url: '/scrm/contact',
    method: 'put',
    data: data
  })
}

// 删除【联系人】
export function delContact(contactId) {
  return request({
    url: '/scrm/contact/' + contactId,
    method: 'delete'
  })
}

// 导出【联系人】
export function exportContact(query) {
  return request({
    url: '/scrm/contact/export',
    method: 'get',
    params: query
  })
}
